import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-project-briefing-completed',
  templateUrl: './activity-item-project-briefing-completed.component.html',
  styleUrls: ['./activity-item-project-briefing-completed.component.scss']
})
export class ActivityItemProjectBriefingCompletedComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;
  
  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

}
